export const WhoWins = () => (
  <iframe
    src="/static/whowins.html"
    title="Durability Dollars"
    style={{ width: "100%", height: "100vh", border: "none", display: "block" }}
    data-testid="whowins-iframe"
  />
);
